<template>
  <div class="header-middle">
    <div class="tabs-head">
      <div class="tabs-wrapper">
        <!--      <span v-show="showNavBar" @click="scrollPrev" class="tabs-nav tabs-nav-prev"><i class="el-icon-arrow-left"></i></span>-->
        <!--      <span v-show="showNavBar" @click="scrollNext" class="tabs-nav tabs-nav-next"><i class="el-icon-arrow-right"></i></span>-->
        <div ref="tabsScrollRef" class="tabs-scroll">
          <ul ref="navRef" class="tabs-head-ul">
            <li v-for="item in topTabList" class="tabs-li" :class="item.id" @click="handleTopTabClick(item)"
                @click.prevent.right="handleTopTabRightClick(item, $event)">
              <a href="javascript:" class="tabs-link" v-bind:class="{'active': item.id === currentPageId}">
                <span class="tabs-txt" :title="item.name">{{ item.name }}</span>
                <span class="tabs-shut" @click.stop="closeTab(item)"><i class="mng icon-cross-stroke"></i></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div
        v-show="showTabMenu"
        :style="[{'left': tabMenuLeft + 'px'}, {'top': tabMenuTop + 'px'}]"
        class="ul-context-menu">
        <ul>
          <li @click="closeCurrentTab" class="ui-context-menu-item">
            <a href="javascript:" class="">
              <span class="">关闭当前</span>
            </a>
          </li>
          <li @click="closeOtherTab" class="ui-context-menu-item">
            <a href="javascript:" class="">
              <span class="">关闭其它</span>
            </a>
          </li>
          <li @click="closeAllTab" class="ui-context-menu-item">
            <a href="javascript:" class="">
              <span class="">关闭所有</span>
            </a>
          </li>
          <li @click="refreshTab" v-show="isCurrentTab" class="ui-context-menu-item">
            <a href="javascript:" class="">
              <span class="">刷新</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
      <div class="tabs-more" v-show="hideTopTabs && hideTopTabs.length > 0" v-clickoutside="closeHideTopTabMenu" :style="{left:tabsMoreLeft + 'px'}">
        <a href="javascript:;" class="tabs-link" @click="clickTabsMore">
          <span class="tabs-icon"><i class="mng icon-lineArrD-stroke"></i></span>
        </a>
        <el-collapse-transition>
            <div class="drop drop-tabs":style="{left:tabsMoreLeft - 138  + 'px'}" style="position: fixed;padding: 0;z-index: 3000" v-if="showTabsMoreList">
              <el-scrollbar :style="{height: scrollHeight + 'px'}" class="whaty-tabs-scroll">
                <div style="position:relative; top:0; left:0;">
                  <ul ref="hideTopTabsUl">
                    <li :class="item.id" class="drop-list" v-for="item in hideTopTabs" @click="handleHideTopTabClick(item)" :title="item.name">
                      <a href="javascript:;" class="tabs-link">
                        <span class="drop-icon"></span>
                        <span class="drop-txt">{{ item.name }}</span>
                        <span class="drop-shut" @click.stop="closeHideTab(item)"><i class="mng icon-cross-stroke"></i></span>
                      </a>
                    </li>
                  </ul>
                </div>
              </el-scrollbar>
            </div>
        </el-collapse-transition>
      </div>
  </div>
</template>
<script>
  import {STORE_APP_MUTATION_TYPES} from '../../libs/constants'
  import { addResizeListener, removeResizeListener } from 'element-ui/src/utils/resize-event'
  import util from '../../libs/util'
  import Clickoutside from 'element-ui/src/utils/clickoutside'

  export default {
    name: 'top-tabs',
    directives: { Clickoutside },
    data() {
      return {
        showTabMenu: false,
        tabMenuLeft: 0,
        isCurrentTab: false,
        tabMenuTop: 0,
        tabMenuOnTab: {}, // 当前tab子菜单出现的tab  id
        showNavBar: false, // 是否显示导航左右移动的按钮
        navOffset: 0, // 导航栏横向偏移量
        showTabsMoreList: false, // 是否显示隐藏导航栏列表
        tabsMoreLeft: 0
      }
    },
    computed: {
      topTabList: function () {
        return this.$store.state.app.topTabList
      },
      hideTopTabs: function () {
        return this.$store.state.app.hideTopTabs
      },
      currentPageId: function () {
        return this.$store.state.app.currentPageId
      },
      tabsWrapperStyle: function () {
        let styleObj = {}
        if (this.showNavBar) {
          styleObj['padding'] = '0 13px'
        }
        return styleObj
      },
      navStyle() {
        return {
          transform: `translateX(-${this.navOffset}px)`
        }
      },
      scrollHeight: function () {
        if (this.hideTopTabs && this.hideTopTabs.length < 0) {
          return 0
        }
        let maxHeight = 221
        return Math.min(this.hideTopTabs.length * 36 + this.hideTopTabs.length - 1, maxHeight)
      }
    },
    mounted() {
      addResizeListener(this.$refs.navRef, this.timeOutUpdate)
      addResizeListener(this.$refs.tabsScrollRef, this.timeOutUpdate)
      util.detectBack(this)
    },
    methods: {
      getDestRouter(tab) {
        return util.getDestRouter(tab)
      },
      closeTab(tab) {
        this.$store.commit(STORE_APP_MUTATION_TYPES.REMOVE_TAB_BY_ID, tab)
        if (this.$store.state.app.currentPageId) {
          const dest = this.getDestRouter(this.$store.state.app.currentTab)
          this.$router.push(dest)
        } else {
          this.$router.push('/')
        }
        if (this.hideTopTabs && this.hideTopTabs.length > 0) {
          // 获取隐藏标签中最后一个 进行删除 并添加到显示标签中
          let hideTopTab = this.hideTopTabs[this.hideTopTabs.length - 1]
          this.$store.commit(STORE_APP_MUTATION_TYPES.REMOVE_HIDE_TAB_BY_ID, hideTopTab)
          this.$store.commit(STORE_APP_MUTATION_TYPES.ADD_ONE_TOP_TAB, hideTopTab)
        }
        this.showTabsMoreList = false
      },
      closeHideTab(tab) {
        let containerSize = this.$refs.tabsScrollRef['offsetWidth']
        let navSize = this.$refs.navRef['offsetWidth']
        if (containerSize > navSize) {
          // 将隐藏页签列当前页签删除
          this.$store.commit(STORE_APP_MUTATION_TYPES.REMOVE_HIDE_TAB_BY_ID, tab)
        }
        this.showTabsMoreList = false
        this.closeTab(tab)
      },
      handleTopTabClick(tab) {
        this.$store.commit(STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_PAGE, tab)
        this.$store.commit(STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_LEFT_MENU, {id: tab.id})
        const dest = this.getDestRouter(tab)
        this.$router.push(dest)
      },
      handleHideTopTabClick(tab) {
        // 将隐藏列页签加入到正常页签中
        this.$store.commit(STORE_APP_MUTATION_TYPES.REMOVE_HIDE_TAB_BY_ID, tab)
        this.$store.commit(STORE_APP_MUTATION_TYPES.ADD_ONE_TOP_TAB, tab)
        this.handleTopTabClick(tab)
        this.showTabsMoreList = false
      },
      handleTopTabRightClick(tab, e) {
        this.tabMenuOnTab = tab
        this.showTabMenu = true
        this.tabMenuLeft = e.clientX
        this.tabMenuTop = e.clientY
        this.isCurrentTab = this.$store.state.app.currentPageId === tab.id
      },
      closeTopTabDropMenu() { // 关闭tab右键的下拉菜单
        this.showTabMenu = false
      },
      closeHideTopTabMenu() { // 关闭tab的隐藏下拉菜单
        this.showTabsMoreList = false
      },
      closeCurrentTab() {
        this.closeTab(this.tabMenuOnTab)
      },
      closeOtherTab() {
        this.$store.commit(STORE_APP_MUTATION_TYPES.CLOSE_OTHER_TABS, this.tabMenuOnTab)
        this.$store.commit(STORE_APP_MUTATION_TYPES.CLOSE_ALL_HIDE_TABS)
      },
      closeAllTab() {
        this.$store.commit(STORE_APP_MUTATION_TYPES.CLOSE_ALL_TABS)
        this.$store.commit(STORE_APP_MUTATION_TYPES.CLOSE_ALL_HIDE_TABS)
        this.$router.push('/')
      },
      refreshTab() {
        this.$store.commit(STORE_APP_MUTATION_TYPES.REMOVE_CACHED_VIEWS, this.tabMenuOnTab)
        this.$store.commit(STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_PAGE, {id: '', routers: []})
        this.$router.push({name: 'loading'})
        this.$store.commit(STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_PAGE, this.tabMenuOnTab)
        setTimeout(() => {
          // this.$router.push({name: this.tabMenuOnTab.id})
          const dest = this.getDestRouter(this.tabMenuOnTab)
          this.$router.push(dest)
          this.$store.commit(STORE_APP_MUTATION_TYPES.ADD_CACHED_VIEWS, this.tabMenuOnTab)
        }, 100)
      },
      timeOutUpdate() {
        // 设置timeout保证异步进行 修复ie浏览器问题
        // 通过设置任务在延迟0毫秒后执行，事件本身并没有延迟，但是能改变任务执行的先后顺序，改变它所调用的函数的优先级，使之异步执行
        setTimeout(() => {
          this.update()
        }, 0)
      },
      update() {
        let currentOffset = this.navOffset
        let containerSize = this.$refs.tabsScrollRef['offsetWidth']
        let navSize = this.$refs.navRef['offsetWidth']
        if (containerSize <= navSize) {
          this.showNavBar = true
          // 判断点击菜单时 页签是否在隐藏列里
          let topTab = null
          if (this.hideTopTabs && this.hideTopTabs.length > 0) {
            for (let hideTopTab of this.hideTopTabs) {
              if (hideTopTab.id === this.currentPageId) {
                topTab = hideTopTab
                break
              }
            }
          }
          if (topTab) {
            // 如果在隐藏列中 删除当前隐藏列页签
            this.$store.commit(STORE_APP_MUTATION_TYPES.REMOVE_HIDE_TAB_BY_ID, topTab)
            this.$store.commit(STORE_APP_MUTATION_TYPES.ADD_ONE_TOP_TAB, topTab)
            this.handleTopTabClick(topTab)
            this.timeOutUpdate()
          } else {
            // 将显示页签推到隐藏页签中 不会将当前页签去隐藏
            let firstTopTab
            for (let i = 0; i < this.topTabList.length; i++) {
              let tab = this.topTabList[i]
              if (tab.id !== this.currentPageId) {
                firstTopTab = tab
                break
              }
            }
            if (firstTopTab) {
              this.$store.commit(STORE_APP_MUTATION_TYPES.REMOVE_TAB_BY_ID, firstTopTab)
              this.$store.commit(STORE_APP_MUTATION_TYPES.ADD_ONE_HIDE_TOP_TAB, firstTopTab)
            }
          }
          if (navSize - currentOffset < containerSize) {
            this.navOffset = navSize - containerSize
          }
        } else {
          // 183页签最大宽度 判断能放下最大宽度的页签
          if (navSize + 183 < containerSize && this.hideTopTabs && this.hideTopTabs.length > 0) {
            let hideTopTab = this.hideTopTabs[this.hideTopTabs.length - 1]
            this.$store.commit(STORE_APP_MUTATION_TYPES.ADD_ONE_TOP_TAB, hideTopTab)
            this.$store.commit(STORE_APP_MUTATION_TYPES.REMOVE_HIDE_TAB_BY_ID, hideTopTab)
          }
          this.showNavBar = false
          if (currentOffset > 0) {
            this.navOffset = 0
          }
        }
        this.calculateTabsMoreLeft()
      },
      scrollPrev() {
        let containerSize = this.$refs.tabsScrollRef['offsetWidth']
        let currentOffset = this.navOffset

        if (!currentOffset) {
          return
        }

        let newOffset = currentOffset > containerSize
          ? currentOffset - containerSize
          : 0

        this.navOffset = newOffset
      },
      scrollNext() {
        let navSize = this.$refs.navRef['offsetWidth']
        let containerSize = this.$refs.tabsScrollRef['offsetWidth']
        const currentOffset = this.navOffset

        if (navSize - currentOffset <= containerSize) {
          return
        }

        let newOffset = navSize - currentOffset > containerSize * 2
          ? currentOffset + containerSize
          : (navSize - containerSize)

        this.navOffset = newOffset
      },
      scrollToActiveTab() {
        const nav = this.$refs.navRef
        const activeTab = this.$el.querySelector('.tabs-cur')
        if (!activeTab) {
          return
        }
        const navScroll = this.$refs.tabsScrollRef
        const activeTabBounding = activeTab.getBoundingClientRect()
        const navScrollBounding = navScroll.getBoundingClientRect()
        const navBounding = nav.getBoundingClientRect()
        const currentOffset = this.navOffset
        let newOffset = currentOffset

        if (activeTabBounding.left < navScrollBounding.left) {
          newOffset = currentOffset - (navScrollBounding.left - activeTabBounding.left)
        }
        if (activeTabBounding.right > navScrollBounding.right) {
          newOffset = currentOffset + activeTabBounding.right - navScrollBounding.right
        }
        if (navBounding.right < navScrollBounding.right) {
          newOffset = nav.offsetWidth - navScrollBounding.width
        }
        this.navOffset = Math.max(newOffset, 0)
      },
      clickTabsMore() {
        this.showTabsMoreList = !this.showTabsMoreList
      },
      calculateTabsMoreLeft() {
        this.$nextTick(() => {
          const activeTab = this.$el.querySelector('.tabs-head-ul')
          let boundingClientRect = activeTab.getBoundingClientRect()
          this.tabsMoreLeft = boundingClientRect.right
        })
      }
    },
    beforeDestroy() {
      if (this.$refs.navRef && this.timeOutUpdate) {
        removeResizeListener(this.$refs.navRef, this.timeOutUpdate)
      }
      if (this.$refs.tabsScrollRef && this.timeOutUpdate) {
        removeResizeListener(this.$refs.tabsScrollRef, this.timeOutUpdate)
      }
    },
    watch: {
      currentPageId: function () {
        this.$nextTick(_ => {
          this.scrollToActiveTab()
        })
      },
      topTabList: function () {
        this.calculateTabsMoreLeft()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/top-tabs/top-tabs.vue